import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { compose } from "recompose";
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions,
         TextField, Button, Chip, Typography } from "@material-ui/core";
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from "moment-timezone";
import t from "../../../languages/pl";
import { displayDateFormat } from '../../../utils/staticData';
import CancelAcceptForm from '../../Common/CancelAcceptForm';
import AssignCarsDialog from "../../Common/AssignCarsDialog";
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from '../../../utils/guid';

const useStyles = theme => ({
    row: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    inputField: {
        margin: theme.spacing(1),
        width: 200
    },
    chip: {
        margin: theme.spacing(1)
    },
    title: {
        marginTop: theme.spacing(1)
    }
});

const AddHoliday = props => {
    const { classes, open, onClose, availableCars, title, carsAssignable, onSubmit } = props;
    const [assignCarsOpen, setAssignCarsOpen] = useState(false);
    const [assignedCars, setAssignedCars] = useState([]);
    const [date, setDate] = useState(moment().unix());
    const [description, setDescription] = useState("");

    const initState = () => {
        setDescription("");
        setDate(moment().unix());
        setAssignedCars([]);
    };

    const handleSubmit = () => {
        let dto = {
            data: date,
            opis: description
        };
        if(!notArrayOrEmpty(assignedCars))
            dto = {...dto, auto_id: assignedCars.map(car => car.auto_id)};
        onSubmit && onSubmit(dto);
        initState();
    };

    const handleAssignCarsSubmit = (carIds) => {
        let cars = availableCars.filter(car => carIds.includes(car.auto_id));
        setAssignedCars(cars);
        setAssignCarsOpen(false);
    };

    const deleteChip = id => {
        setAssignedCars(cars => cars.filter(car => car.auto_id !== id));
    };

    const printChips = data => {
        if(notArrayOrEmpty(data))
            return <Typography variant="body1">{t.noAssignedCars}</Typography>;
        return data.map(chip => (
            <Chip
                className={classes.chip}
                key={guid()}
                label={chip.rejestracja}
                onDelete={() => deleteChip(chip.auto_id)}
            />
        ));
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                <div className={classes.row}>
                    <TextField
                        label={t.description}
                        className={classes.inputField}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                    />
                    <KeyboardDatePicker
                        label={t.date}
                        required
                        placeholder="__/__/____"
                        minDateMessage={t.dateCannotBeEarlierThanMinimumDate}
                        maxDateMessage={t.dateCannotBeLaterThanMaximumDate}
                        format={displayDateFormat}
                        className={classes.inputField}
                        value={date === 0 ? null : moment.unix(date)}
                        invalidDateMessage={t.invalidDateFormat}
                        onChange={(e) => e ? setDate(e.unix()) : setDate(0)}
                    />
                </div>
                {
                    carsAssignable
                    &&
                    <>
                        <div className={classes.row}>
                        <Typography variant="subtitle1" className={classes.title}>{t.cars}</Typography>
                        </div>
                        <div className={classes.row}>
                            {printChips(assignedCars)}
                        </div>
                    </>
                }
            </DialogContent>
            <DialogActions>
                {
                    carsAssignable ?
                        <React.Fragment>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setAssignCarsOpen(true)}
                            >
                                {t.assignCars}
                            </Button>
                            <CancelAcceptForm
                                onCancel={onClose}
                                disableSubmit={description === "" || date === 0 || isNaN(date) || notArrayOrEmpty(assignedCars)}
                                onSubmit={handleSubmit} />
                        </React.Fragment>
                        :
                        <CancelAcceptForm
                            onCancel={onClose}
                            disableSubmit={description === "" || date === 0 || isNaN(date)}
                            onSubmit={handleSubmit}
                        />

                }
            </DialogActions>
            {
                assignCarsOpen
                &&
                <AssignCarsDialog
                    open={assignCarsOpen}
                    onClose={() => setAssignCarsOpen(false)}
                    onSubmit={handleAssignCarsSubmit}
                    carsInGroup={assignedCars}
                />
            }
        </Dialog>
    );
};

const mapStateToProps = state => ({
    availableCars: state.carsReducer.cars,
});

AddHoliday.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    carsAssignable: PropTypes.bool,
    onSubmit: PropTypes.func,
    //redux
    availableCars: PropTypes.array
};

export default compose(
    withStyles(useStyles),
    connect(mapStateToProps)
)(AddHoliday);
